module.exports = __webpack_public_path__ + "img/dot.4a55fca6.svg";